export const getAccessToken = () => localStorage.getItem('is_loggedin');

export const isAuthenticated = () => (getAccessToken() ? true : false);
